<template>
  <v-layout row justify-center>
    <v-dialog v-model="templatedialog" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('item_import_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="save">{{ $t('save') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md style="background-color: white;">
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  :items="templates"
                  v-model="selected_templates"
                  label="Audit Templates"
                  hint="Zu Verfügung stehende Audit-Templates"
                  persistent-hint
                >
                  <template slot="item" slot-scope="item">{{ item.item.name }}</template>

                  <template slot="selection" slot-scope="item">{{ item.item.name }}</template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md12 id="paginationstart">
                <template v-if="isGroupable">
                  <v-container pa-1>
                    <v-layout row ma-1>
                      <v-flex xs9 offset-xs1 wrap>Audititem</v-flex>
                      <v-flex xs2 style="text-align: right;">Gewichtung</v-flex>
                    </v-layout>
                  </v-container>

                  <v-checkbox
                    v-model="selectAll"
                    :indeterminate="selectAllIndeterminate"
                    label="Alle auswählen"
                  />
                  <v-treeview
                    selectable
                    selected-color="red"
                    :items="groupedItems"
                    v-model="treeSelected"
                  >
                    <template v-slot:label="{item,  leaf}">
                      <div v-if="!leaf">
                        <SnippetCategory
                          :category-id="item.category_id"
                          :standard-id="templateStandard"
                        />
                        {{item.children.reduce( (prev, child) => { return prev + (treeSelected.includes(child.id) ? 1 : 0)}, 0)}}/{{item.children.length}}
                      </div>
                      <div v-else>
                        <v-container pa-1>
                          <v-layout row ma-1>
                            <v-flex xs10 wrap>{{ item.question.text }}</v-flex>
                            <v-flex xs2 style="text-align: right;">{{ item.question.importance }}</v-flex>
                          </v-layout>
                        </v-container>
                      </div>
                    </template>
                  </v-treeview>
                  <!-- <pre>{{treeSelectedIds}}</pre> -->
                </template>
                <template v-else>
                  <v-data-table
                    :headers="headers"
                    :items="templateAuditItems"
                    :search="search"
                    hide-actions
                    :pagination="listConfigPaginationDataTable"
                    no-data-text="Please select a template to import audit questions"
                    v-model="selected"
                    item-key="id"
                    select-all
                    class="elevation-1"
                  >
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <span slot="activator">{{ props.header.text }}</span>
                        <span>{{ props.header.text }}</span>
                      </v-tooltip>
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr @click="props.expanded = !props.expanded">
                        <td>
                          <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>
                          <SnippetCategory
                            :category-id="props.item.question.category"
                            :standard-id="templateStandard"
                          />
                        </td>
                        <td>{{ props.item.question.text }}</td>
                        <td>{{ props.item.question.importance }}</td>
                      </tr>
                    </template>
                    <template v-slot:expand="props">
                      <v-card flat>
                        <v-card-text>Peek-a-boo!</v-card-text>
                      </v-card>
                    </template>
                  </v-data-table>
                  <PaginationControl
                    v-if="listConfigPaginationRequired"
                    :page-sizes="listConfigPageSizes"
                    :length="listConfigPageCount"
                    @change="listConfigOnPaginationChange"
                  />
                </template>
              </v-flex>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">{{ $t('cancel') }}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">{{ $t('save') }}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
  {
    "de": {
      "item_import_title" : "Fragen importieren",
      "save" : "Speichern",
      "cancel" : "Abbrechen"
    },
    "en": {
      "item_import_title" : "Import Items",
      "save" : "Save",
      "cancel" : "Cancel"
    }
  }
</i18n>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import { api as templatesapi } from "@/store/modules/templates";
import SnippetCategory from "@/components/snippets/SnippetCategory";
import PaginationControl from "@/components/controls/PaginationControl";
import ListConfigurationMixin from "@/components/mixins/ListConfigurationMixin";

const CATEGORY_ID_PREFIX = "CATEGORY-ID-IIKKSHHJFKJSZU-";

export default {
  props: {
    templatedialog: {
      default: true
    },
    currentAudit: {
      type: Object,
      default: () => ({})
    },
    currentStore: {
      type: String,
      default: "audits"
    }
  },
  components: {
    SnippetCategory,
    PaginationControl
  },
  mixins: [ListConfigurationMixin],
  data: () => ({
    treeSelected: [],
    selectAll: false,
    importance: ["0", "1", "3", "9"],
    currentTemplate: null,
    selected: [],
    selected_templates: null,
    search: "",
    headers: [
      { text: "Category", value: "category" },
      { text: "Audit Item", value: "name" },
      { text: "Importance", value: "importance" }
    ]
  }),
  computed: {
    ...mapGetters(templatesapi.namespace, [
      templatesapi.getters.loadedAudits,
      templatesapi.getters.loadedAudit
    ]),
    templates() {
      return this.loadedAudits;
    },
    templateStandard() {
      if (this.selected_templates) {
        return this.selected_templates.standard || "default";
      }
      return "default";
    },
    templateAuditItems() {
      if (this.selected_templates) {
        const template_items = this.loadedAudit(this.selected_templates.id)
          .audit_items;

        const audit_items = [];
        const obj = template_items;
        for (let key in obj) {
          audit_items.push({ ...obj[key], id: key });
        }
        console.log("Items", audit_items);

        // TODO Mapping mit Importance

        return audit_items;
      } else {
        return [];
      }
    },
    treeSelectedIds() {
      return this.treeSelected.filter(
        id => id.substr(0, CATEGORY_ID_PREFIX.length) !== CATEGORY_ID_PREFIX
      );
    },
    isGroupable() {
      return this.groupedItems.length > 1;
    },
    groupedItems() {
      const grouped = {};
      this.templateAuditItems.forEach(item => {
        let category_id = "";
        if (item && item.question && item.question.category) {
          category_id = item.question.category;
        }

        if (category_id in grouped) {
          grouped[category_id].children.push(item);
        } else {
          grouped[category_id] = {
            children: [item],
            category_id: category_id,
            id: CATEGORY_ID_PREFIX + String(category_id)
          };
        }
      });

      return Object.values(grouped);
    },
    selectedAuditItems() {
      if (this.isGroupable) {
        const allItems = this.templateAuditItems;
        return this.treeSelectedIds.map(id => {
          const item = allItems.find(item => item.id === id);
          return item;
        });
      } else {
        return this.selected;
      }
    },
    existingAuditItems() {
      console.log("Existing Audit-Items");
      console.log(this.currentAudit.id);

      const template_items = { ...this.currentAudit.audit_items };

      const audit_items = [];

      for (const audit in template_items) {
        audit_items.push(audit);
      }

      console.log(audit_items);
      return audit_items;
    },
    selectAllIndeterminate() {
      return (
        this.treeSelected.length > 0 &&
        this.treeSelected.length < this.templateAuditItems.length
      );
    },

    // Overwrites from ListConfigurationMixin
    listConfigConfigKey: () => "templateselection",
    listConfigTotalItemCount() {
      return this.templateAuditItems.length;
    }
  },
  methods: {
    //  TODO: Richten Store mit mapActions bekommen
    close() {
      this.$emit("update:templatedialog", false);
    },

    save() {
      console.log("Save Template Dialog", this.currentStore);

      const audit_items = _.cloneDeep(this.selectedAuditItems);
      console.log(audit_items);

      const payload = {
        audit_id: this.currentAudit.id,
        data: audit_items
      };

      if (this.currentStore == "audits") {
        this.$store.dispatch("audits/createAuditItem", payload);
      } else {
        this.$store.dispatch("templates/createAuditItem", payload);
      }

      //this.createAuditItem(payload);

      this.close();
    }
  },
  watch: {
    selectAll(newValue) {
      if (newValue) {
        this.treeSelected = this.templateAuditItems.map(item => item.id);
      } else {
        this.treeSelected = [];
      }
    }
  }
};
</script>
<style>
.v-treeview-node--leaf > .v-treeview-node__root {
  /* border: 1px solid rgba(0, 0, 0, 0.12); */
  margin: 6px 0;
}

.v-treeview-node--leaf > .v-treeview-node__root > .v-treeview-node__content {
  max-width: 90%;
  width: 90%;
}
.v-treeview-node--leaf .v-treeview-node__label {
  font-size: 90%;
  max-width: 100%;
  width: 100%;
}
</style>
